var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1665 17.3337H12.8332M1.1665 0.666992H12.8332M11.1665 17.3337V13.857C11.1664 13.415 10.9908 12.9911 10.6782 12.6787L6.99984 9.00033M6.99984 9.00033L3.3215 12.6787C3.00892 12.9911 2.83326 13.415 2.83317 13.857V17.3337M6.99984 9.00033L3.3215 5.32199C3.00892 5.0095 2.83326 4.58565 2.83317 4.14366V0.666992M6.99984 9.00033L10.6782 5.32199C10.9908 5.0095 11.1664 4.58565 11.1665 4.14366V0.666992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.9fc5dfef.svg";
export { ForwardRef as ReactComponent };